import { z } from 'zod';
import { CoreDocumentsResourceTypeSchema } from '../inputTypeSchemas/CoreDocumentsResourceTypeSchema'

/////////////////////////////////////////
// CORE DOCUMENT SCHEMA
/////////////////////////////////////////

export const CoreDocumentSchema = z.object({
  resourceType: CoreDocumentsResourceTypeSchema.nullable(),
  id: z.number().int(),
  cityId: z.number().int(),
  s3Url: z.string().nullable(),
  s3Bucket: z.string().nullable(),
  s3Key: z.string().nullable(),
  resourceId: z.number().int().nullable(),
  deactivatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  issuedAt: z.coerce.date().nullable(),
})

export type CoreDocument = z.infer<typeof CoreDocumentSchema>

export default CoreDocumentSchema;
